// extracted by mini-css-extract-plugin
export default {"image":"Source_image__3pCFB"};